import React, { Component } from "react";
import { getOutletPendingReceivedItems } from "../../../../../services/sales/outletService";
import { formatDate } from "../../../../../utils/utils";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import { Badge } from "react-bootstrap";
import Illustration from "../../../../../partials/content/Illustration";
import SideBarLayout from "../../../../../partials/content/SideBarLayout";
import ItemsReceiveForm from "../../../inventory/stock-management/item-receive/itemsReceiveForm";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import withGlobalData from "../../../common/withGlobalData";
class OutletReceiveItems extends Component {
  state = {
    reload: this.props.globalData.reload,
    transferID: 0,
    selectedTransfer: {},
    openItemsReceive: false,
    pendingReceivedItems: [],
    outletReceiveDetailColumn: [
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
  };

  componentDidMount() {
    this.getOutletPendingReceivedItems();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getOutletPendingReceivedItems();
      this.setState({ reload: globalData.reload });
    }
  }

  async getOutletPendingReceivedItems() {
    const { outletID = 0 } = this.props.match.params;
    const response = await getOutletPendingReceivedItems(outletID);
    const { data } = response.data;
    this.setState({ pendingReceivedItems: data.itemsTransfer });
  }

  render() {
    const { outletID = 0 } = this.props.match.params;
    const {
      pendingReceivedItems,
      selectedTransfer,
      openItemsReceive,
      transferID,
      outletReceiveDetailColumn,
    } = this.state;
    return (
      <React.Fragment>
        {pendingReceivedItems.length ? (
          <React.Fragment>
            <CustomDataTable
              data={pendingReceivedItems}
              dataDetailColumns={outletReceiveDetailColumn}
              onRefreshData={() => {
                this.getOutletPendingReceivedItems();
              }}
              columns={[
                {
                  header: "Transfer ID",
                  field: "ID",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Source Type",
                  field: "fromLocationType",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.fromLocationType}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Source Location",
                  field: "fromLocation",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.fromLocation}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Goods Receive Status",
                  field: "grStatusDesc",
                  body: (rowData) => {
                    if (rowData.grStatus === 1) {
                      return (
                        <Badge variant="danger">{rowData.grStatusDesc}</Badge>
                      );
                    } else if (rowData.grStatus === 2) {
                      return (
                        <Badge variant="warning">{rowData.grStatusDesc}</Badge>
                      );
                    } else if (rowData.grStatus === 3) {
                      return (
                        <Badge variant="success">{rowData.grStatusDesc}</Badge>
                      );
                    } else {
                      return (
                        <Badge variant="dark">{rowData.grStatusDesc}</Badge>
                      );
                    }
                  },
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Movement Date",
                  field: "moveDate",
                  body: (rowData) => formatDate(rowData.moveDate),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Actions",
                  body: (rowData) => (
                    <React.Fragment>
                      <BootstrapTooltip title="Receive Items">
                        <button
                          type="button"
                          onClick={() => {
                            const transferID = rowData.ID;
                            this.setState({
                              openItemsReceive: true,
                              transferID,
                              selectedTransfer: rowData,
                            });
                          }}
                          className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-truck-loading"></i>
                        </button>
                      </BootstrapTooltip>
                    </React.Fragment>
                  ),
                  sortable: false,
                },
              ]}
            />
          </React.Fragment>
        ) : (
          <Illustration
            imageSource="INVIFO Procurement.png"
            description="Hooray! You're ready to receive Items Requested from the valuable warehouses!"
            guidance="Hint: once the Items Transfer is created from the warehouses to this outlet, it will be displayed here"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
            size="md"
          ></Illustration>
        )}
        <SideBarLayout
          title="Goods Received Form"
          visible={openItemsReceive}
          position="right"
          minWidthPercent="90%"
          onHide={() => this.handleCloseItemsReceive()}
        >
          <ItemsReceiveForm
            po={{ ID: 0 }}
            transfer={selectedTransfer}
            transferID={transferID}
            warehouseID={0}
            outletID={outletID}
            onSubmitReceivedItem={this.handleSubmitReceivedItem}
            onCloseItemsReceive={this.handleCloseItemsReceive}
          />
        </SideBarLayout>
      </React.Fragment>
    );
  }

  handleSubmitReceivedItem = () => {
    this.getOutletPendingReceivedItems();
    this.setState({ openItemsReceive: false });
  };

  handleCloseItemsReceive = () => {
    this.setState({ openItemsReceive: false });
  };

  handleOpenItemsReceive = () => {
    this.setState({ openItemsReceive: true });
  };
}

export default withGlobalData(OutletReceiveItems);
